var map = {
	"./4brand/TOP.png": "1e42",
	"./4brand/logo/bud.png": "85fd",
	"./4brand/logo/byd.png": "470c2",
	"./4brand/logo/gsk.png": "3f99",
	"./4brand/logo/henkel.png": "2faf",
	"./4brand/logo/max.png": "4294",
	"./4brand/logo/nestle.png": "b57d",
	"./4brand/logo/下载 (4).png": "08d2",
	"./4brand/logo/中国移动.png": "292c",
	"./4brand/logo/京东.png": "eaaa",
	"./4brand/logo/南孚电池.png": "fffd",
	"./4brand/logo/哔哩哔哩.png": "6692",
	"./4brand/logo/唯品会.png": "ec27",
	"./4brand/logo/喜马拉雅.png": "6577",
	"./4brand/logo/威马汽车.png": "de08",
	"./4brand/logo/抖音.png": "f9bf",
	"./4brand/logo/方回春堂.png": "8851",
	"./4brand/logo/方太.png": "0aa7",
	"./4brand/logo/松下电器.png": "2938",
	"./4brand/logo/欧普照明.png": "ff37",
	"./4brand/logo/欧莱雅.png": "210a",
	"./4brand/logo/畅轻.png": "6258",
	"./4brand/logo/美的logo.png": "a887",
	"./4brand/logo/美赞臣.png": "865a",
	"./4brand/logo/蒙牛.png": "de3a",
	"./4brand/logo/西门子.png": "0f0e",
	"./4brand/logo/迪士尼.png": "f25b",
	"./4brand/logo/雅诗兰黛.png": "45c7",
	"./4brand/logo/零跑汽车.png": "2ec3",
	"./4brand/logo/青岛啤酒.png": "a009",
	"./4brand/logo/领克.png": "eb35",
	"./4brand/logo/飞利浦.png": "a28d",
	"./4brand/logo/驴妈妈旅游.png": "4def",
	"./4brand/logo/高德地图.png": "5cf9",
	"./4brand/logo/麦当劳.png": "fbca",
	"./4brand/logo/黑人牙膏.png": "51d1",
	"./4brand/三大核心背景.png": "41ec",
	"./4brand/中间.png": "4fc9",
	"./4brand/内圈箭头.png": "9ee4",
	"./4brand/内层通道.png": "e2bd",
	"./4brand/右通风.png": "0d7f",
	"./4brand/外圈箭头.png": "c189",
	"./4brand/大通道.png": "a43e",
	"./4brand/左上图标.png": "7734",
	"./4brand/左通风.png": "97ac",
	"./4brand/数字营销.png": "4d8a",
	"./4brand/标题1.png": "df39",
	"./4brand/椭圆点.png": "f1f1",
	"./4brand/漂浮.png": "d16c",
	"./4brand/箭头.png": "2222",
	"./4brand/背景.png": "f026",
	"./4brand/透明化流量.png": "3774",
	"./4brand/透明背景右.png": "d566",
	"./4brand/透明背景左.png": "1d9d",
	"./5lab/5高校实验室Bg.png": "c3fe",
	"./5lab/title5.png": "73a2",
	"./5lab/zjdxbg.png": "d531",
	"./5lab/上海学校bg.png": "8e3e",
	"./5lab/实验室盒子bg.png": "9ff2",
	"./5lab/浙江学校bg.png": "0f37",
	"./5lab/魔方.png": "b1cd",
	"./6企业实力/6企业实力bg.png": "e76d",
	"./6企业实力/building.png": "2f9e",
	"./6企业实力/flower.png": "05dd",
	"./6企业实力/中间bg1.png": "d7a5",
	"./6企业实力/中间bg2.png": "517c",
	"./6企业实力/右上center.png": "dcf4",
	"./6企业实力/右上气泡框.png": "8706",
	"./6企业实力/右上箭头.png": "c606",
	"./6企业实力/右下气泡框.png": "5c69",
	"./6企业实力/右下箭头.png": "08fd",
	"./6企业实力/多圈圆.png": "6070",
	"./6企业实力/多边形 1 拷贝.png": "a96bb",
	"./6企业实力/左上气泡框.png": "fe33",
	"./6企业实力/左上箭头.png": "895b",
	"./6企业实力/左下气泡框.png": "c75a",
	"./6企业实力/左下箭头.png": "a8d1",
	"./6企业实力/技术与安全icon.png": "a1f1",
	"./6企业实力/政府合作项目icon.png": "ae8c",
	"./6企业实力/标题1.png": "ade3",
	"./6企业实力/矩形 3 拷贝.png": "b620",
	"./6企业实力/证书.png": "4a88",
	"./6企业实力/软件著作权icon.png": "1bfc",
	"./6企业实力/软著案例icon.png": "e4a6",
	"./center/a.png": "24fb",
	"./center/arrow_bottom.png": "e814",
	"./center/arrow_top.png": "18b9",
	"./center/b.png": "274f",
	"./center/bg.png": "0fc7",
	"./center/center11.png": "7346",
	"./center/center22.png": "43c5",
	"./center/center44.png": "db7a",
	"./center/center55.png": "f8ea",
	"./center/center_bg1.png": "28ba",
	"./center/center_item.png": "7545",
	"./center/center_item_person.png": "e266",
	"./center/center_logo.png": "0296",
	"./center/cir1.png": "b023",
	"./center/cir2.png": "2ddb",
	"./center/cir3.png": "f519",
	"./center/cir4.png": "cea7",
	"./center/jt1.png": "470c",
	"./center/jt2.png": "1680",
	"./center/left_bg.png": "791a",
	"./center/left_img1.png": "266a",
	"./center/left_img2.png": "4bd9",
	"./center/left_img2_原_备份.png": "bcea",
	"./center/left_img3.png": "3fed",
	"./center/left_img3_原_备份.png": "eb92",
	"./center/right_bg.png": "c6e5",
	"./center/right_img1.png": "d250",
	"./center/right_img2.png": "db91",
	"./center/title.png": "8921",
	"./cirL.png": "99d0",
	"./cirR.png": "9bde",
	"./cirb.png": "901c",
	"./circle.png": "088b",
	"./dz.png": "a64c",
	"./font/SourceHanSans-Bold.otf": "f679",
	"./font/SourceHanSans-Medium.otf": "1ca0",
	"./font/SourceHanSans-Normal.otf": "022e",
	"./font/SourceHanSans-Regular.otf": "e055",
	"./font/font.css": "3394",
	"./font/helvetica-bold.woff.ttf": "baf6",
	"./headBar.png": "a49c",
	"./human.png": "89c2",
	"./hy1.png": "5f5d",
	"./hy2.png": "99a9",
	"./hy3.png": "3319",
	"./hy4.png": "81ab",
	"./hy5.png": "3d4e",
	"./icon1.png": "b45a",
	"./icon2.png": "50d3",
	"./icon3.png": "b5c1",
	"./icon4.png": "b605",
	"./icon5.png": "8a49",
	"./icon6.png": "84cec",
	"./industry1.png": "23a4",
	"./industry1_active.png": "584c",
	"./industry2.png": "5bea",
	"./industry2_active.png": "12fc",
	"./industry3.png": "53f1",
	"./industry3_active.png": "09c8",
	"./industry4.png": "e1ac",
	"./industry4_active.png": "df5f",
	"./industry5.png": "dc7c",
	"./industry5_active.png": "c2ef",
	"./industry_border.png": "4246",
	"./industry_line.png": "0af3",
	"./itembg.png": "957b",
	"./itembg2.png": "0825",
	"./listbg.png": "df1e",
	"./logo.png": "cf05",
	"./newpagebg1.jpg": "797c",
	"./newpagebg2.jpg": "9340",
	"./newpagebg3.jpg": "df63",
	"./newpagebg4.jpg": "55d8",
	"./newpagebg5.jpg": "d78d",
	"./num_bg.png": "2597",
	"./page1bg.png": "92ad",
	"./page2bg.png": "6760",
	"./page3bg.png": "d5fd",
	"./pagel.png": "adfb",
	"./pager.png": "ed16",
	"./pie.png": "411d",
	"./pie11111.png": "1312",
	"./title1.png": "acc1",
	"./title2.png": "560d",
	"./title3.png": "f0c6",
	"./title4.png": "028c",
	"./title5.png": "a630",
	"./title6.png": "61df",
	"./titlebg.png": "ede1",
	"./top.png": "6fc9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";